import { render } from "./App.vue?vue&type=template&id=b33bef5c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b33bef5c&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__